var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkPrimary = function SvgIconLinkPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M19 9a1 1 0 1 0 2 0V5a2 2 0 0 0-2-2h-4a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 0 0 1.414 1.414L19 6.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    fillRule: "evenodd",
    d: "M3 6a3 3 0 0 1 3-3h5a1 1 0 1 1 0 2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 1 1 2 0v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLinkPrimary;